import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon, Print as PrintIcon } from '@material-ui/icons'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { FacilityLabel } from 'src/components/PrintLabel/FacilityLabel'
import { DockDialog } from 'src/modules/supply_chain/components/DockDialog'
import { RelatedLinkedField, ValueField } from 'src/components/Table'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const DockDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)
  const { print, renderPrintComponent } = useAsyncPrint()

  return (
    <>
      {renderPrintComponent()}
      {updateOpen && (
        <DockDialog
          open={updateOpen}
          dock={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Dock', onClick: () => setUpdateOpen(true) }],
          },
          {
            Icon: PrintIcon,
            actions: [
              {
                title: 'Print Dock Label',
                onClick: () => print((props) => <FacilityLabel {...props} obj={obj.data} />),
              },
            ],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'facility', label: 'Facility', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'name', label: 'Name', renderer: ValueField },
          { id: 'dockType', label: 'Dock Type', renderer: ValueField },
        ]}
      />
    </>
  )
}
